module.exports = __webpack_public_path__ + "img/white.3fabd2ec.svg";